import { render, staticRenderFns } from "./JoinMeeting.vue?vue&type=template&id=496ae184&scoped=true&"
import script from "./JoinMeeting.vue?vue&type=script&lang=js&"
export * from "./JoinMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ae184",
  null
  
)

export default component.exports